import React, { useState } from 'react'

import { send } from 'emailjs-com';

const ContactFormCard = () => {
    const [emailSent, setEmailSent] = useState('')

    const [formIsValid, setFormIsValid] = useState('')

    const [state, setState] = useState({
        fields: {},
        errors: {}
    });

    const [toSend, setToSend] = useState({
        from_name: '',
        from_email: '',
        to_email: 'piyushtalele.6491@gmail.com',
        message: ''
    });



    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;

        //Name
        if (!toSend.from_name) {
            formIsValid = false;
            errors["from_name"] = "Cannot be empty";
        }

        if (typeof toSend.from_name !== "undefined") {
            if (!toSend.from_name.match(/^[a-z ,.'-]+$/i)) {
                formIsValid = false;
                errors["name"] = "Only letters";
            }
        }

        //Email
        if (!toSend.from_email && toSend.from_email !== "undefined") {
            formIsValid = false;
            errors["from_email"] = "Cannot be empty";
        } else if (!toSend.from_email.match(/^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/)) {
            formIsValid = false;
            errors["from_email"] = "Email is not valid";
        }


        //message
        if (!toSend.message && typeof toSend.message !== "undefined") {
            formIsValid = false;
            errors["message"] = "Cannot be empty";
        }


        setState({ errors: errors });
        setFormIsValid(formIsValid);
        return formIsValid;
    }


    const sendMail = () => {
        var message = toSend.message;
        toSend.message = 'Email from : '+ toSend.from_email+' /n message : ' + toSend.message;

        send(
            'service_gkiqe1v',
            'template_mmwuidn',
            toSend,
            'user_G49K24beZlSwi5ydDgqrJ'
        )
            .then((response) => {
                console.log('SUCCESS!', response.status, response.text);
                setEmailSent("success");
            })
            .catch((err) => {
                console.log('FAILED...', err);
                setEmailSent("failed");
            });
        toSend.message = message;
    }


    const onSubmit = (e) => {
        e.preventDefault();
        if (handleValidation()) {
            sendMail();
        }
    };



    const handleChange = (e) => {
        setEmailSent("");
        setToSend({ ...toSend, [e.target.name]: e.target.value });
            
    };

    return (
        <div className="content contacts">

            <div className="title">Contact Form</div>
            <div className="contact-div">
                <div className="row">
                    <div className="col col-d-12 col-t-12 col-m-12 border-line-v">
                        <div className="contact_form">
                            <div className="fields">
                                <form id="cform" method="post" onSubmit={onSubmit}>
                                    <div className="row">
                                        <div className="col col-d-6 col-t-6 col-m-12">
                                            <div className={(!state.errors["from_name"] && typeof state.errors["from_name"] == "undefined") ? "fieldsContact" : "fieldsContact error"}>
                                                <svg fill="#999" viewBox="0 0 1024 1024">
                                                    <path className="path1" d="M896 307.2h-819.2c-42.347 0-76.8 34.453-76.8 76.8v460.8c0 42.349 34.453 76.8 76.8 76.8h819.2c42.349 0 76.8-34.451 76.8-76.8v-460.8c0-42.347-34.451-76.8-76.8-76.8zM896 358.4c1.514 0 2.99 0.158 4.434 0.411l-385.632 257.090c-14.862 9.907-41.938 9.907-56.802 0l-385.634-257.090c1.443-0.253 2.92-0.411 4.434-0.411h819.2zM896 870.4h-819.2c-14.115 0-25.6-11.485-25.6-25.6v-438.566l378.4 252.267c15.925 10.618 36.363 15.925 56.8 15.925s40.877-5.307 56.802-15.925l378.398-252.267v438.566c0 14.115-11.485 25.6-25.6 25.6z">
                                                    </path>
                                                </svg>
                                                <input type="fullName" name="from_name" className="user-input" placeholder="Full Name" onChange={handleChange} value={toSend.from_name} />
                                            </div>
                                            {
                                                (!state.errors["from_name"] || typeof state.errors["from_name"] == "undefined") ?
                                                    null : <span className="error">{state.errors["from_name"]}</span>
                                            }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col col-d-6 col-t-6 col-m-12">
                                            <div className={(!state.errors["from_email"] && typeof state.errors["from_email"] == "undefined") ? "fieldsContact" : "fieldsContact error"}>
                                                <svg fill="#999" viewBox="0 0 1024 1024">
                                                    <path className="path1" d="M896 307.2h-819.2c-42.347 0-76.8 34.453-76.8 76.8v460.8c0 42.349 34.453 76.8 76.8 76.8h819.2c42.349 0 76.8-34.451 76.8-76.8v-460.8c0-42.347-34.451-76.8-76.8-76.8zM896 358.4c1.514 0 2.99 0.158 4.434 0.411l-385.632 257.090c-14.862 9.907-41.938 9.907-56.802 0l-385.634-257.090c1.443-0.253 2.92-0.411 4.434-0.411h819.2zM896 870.4h-819.2c-14.115 0-25.6-11.485-25.6-25.6v-438.566l378.4 252.267c15.925 10.618 36.363 15.925 56.8 15.925s40.877-5.307 56.802-15.925l378.398-252.267v438.566c0 14.115-11.485 25.6-25.6 25.6z">
                                                    </path>
                                                </svg>
                                                <input type="emailId" name="from_email" className="user-input" placeholder="Your Email Address" onChange={handleChange} value={toSend.from_email} />
                                            </div>
                                            {
                                                (!state.errors["from_email"] || typeof state.errors["from_email"] == "undefined") ?
                                                    null : <span className="error">{state.errors["from_email"]}</span>
                                            }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col col-d-12 col-t-12 col-m-12">
                                            <div className={(!state.errors["message"] && typeof state.errors["message"] == "undefined") ? "fieldsContact EmailMessage" : "fieldsContact EmailMessage error"}>
                                                <textarea type="message" name="message" className="user-input" placeholder="Your EmailMessage" value={toSend.message} onChange={handleChange} />
                                            </div>
                                            {
                                                (!state.errors["message"] || typeof state.errors["message"] == "undefined") ?
                                                    null : <span className="error">{state.errors["message"]}</span>
                                            }
                                        </div>
                                    </div>
                                    <div className="align-left">

                                        <button className="contactme-button" type='submit' type="submit">Send Message</button>

                                    </div>
                                </form>
                                <div className={emailSent == 'success' ? "" : "alert-success"}>
                                    <p>Thanks, your message is sent successfully.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="clear"></div>
                </div>
            </div>
        </div >
    );
}

export default ContactFormCard;